import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Container,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Dropdown, Button, Modal } from "react-bootstrap";
import { CountryDropdown } from "react-country-region-selector";
import "../components/App.css";
import dayjs from "dayjs";
import { ADMIN_BASE_URL } from "../config/config";

const AdminClaim = () => {
  const [pendingClaims, setPendingClaims] = useState([]);
  const [completedClaims, setCompletedClaims] = useState([]);
  const [selectedClaimId, setSelectedClaimId] = useState(null);
  const [selectedClaimStatus, setSelectedClaimStatus] = useState("");
  const [country, setCountry] = useState("");
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    fetchPendingClaims();
    fetchCompletedClaims();
  }, [country]);

  const fetchPendingClaims = async () => {
    try {
      const response = await axios.get(
        `${ADMIN_BASE_URL}/viewclaims`,
        { params: { status: "Observing", country: country } }
      );
      setPendingClaims(response.data);
      console.log(response.data);
    } catch (error) {
      console.error("Error fetching pending claims:", error);
    }
  };

  const fetchCompletedClaims = async () => {
    try {
      const response = await axios.get(
        `${ADMIN_BASE_URL}/viewclaims`,
        { params: { status: "completed", country: country } }
      );
      setCompletedClaims(response.data);
    } catch (error) {
      console.error("Error fetching completed claims:", error);
    }
  };

  const handleChangeCountry = (val) => {
    setCountry(val);
  };

  const handleStatusUpdate = async () => {
    try {
      const message = document.getElementById("adminMessage").value;
      const amount = document.getElementById("adminAmount").value;

      console.log("message", message);
      console.log("amount", amount);
      const response = await axios.post(
        `${ADMIN_BASE_URL}/updateclaim`,
        {
          admin_message: message,
          admin_amount: amount,
        },
        {
          params: {
            claim_id: selectedClaimId,
            status: selectedClaimStatus,
          },
        }
      );

      console.log("response", response);

      document.getElementById("adminMessage").value = "";
      document.getElementById("adminAmount").value = "";

      handleCloseModal();
      fetchPendingClaims();
      fetchCompletedClaims();
    } catch (error) {
      console.error("Error updating claim status:", error);
    }
  };

  const handleShowModal = (claimId) => {
    setSelectedClaimId(claimId);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setSelectedClaimId(null);
    setSelectedClaimStatus("");
    setShowModal(false);
  };

  const formatDate = (date) => {
    return dayjs(date).format("DD-MM-YYYY");
  };

  const openImageInNewTab = (imageUrl) => {
    window.open(imageUrl, "_blank");
  };

  return (
    <Container>
        <Typography
          style={{ marginBottom: "2rem" }}
          variant="h4"
          className="admin-message-title"
          gutterBottom
        >
          User Claims
        </Typography>
        <div style={{ textAlign: "center" }}>
          <CountryDropdown
            value={country}
            onChange={handleChangeCountry}
            labelType="full"
            className="admin-country-dropdown"
          />
        </div>
        <Typography style={{ marginTop: "2rem" }} variant="h5">
          Pending Claims
        </Typography>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Claim ID</TableCell>
                <TableCell>Date of Claim Request</TableCell>
                <TableCell>Claim Type</TableCell>
                <TableCell>Uploaded Documents</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Bank Account Name</TableCell>
                <TableCell>Bank Account Number</TableCell>
                <TableCell>Account Holder' Name</TableCell>
                <TableCell>Swift Code</TableCell>
                <TableCell>Branch Address</TableCell>
                <TableCell>Contact Number</TableCell>
                <TableCell>Update Claim Value</TableCell>
                <TableCell>Update Claim Details</TableCell>
                <TableCell>Update Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {pendingClaims.map((claim, index) => (
                <TableRow key={index}>
                  <TableCell>{claim.claim_id}</TableCell>
                  <TableCell>{formatDate(claim.created_date)}</TableCell>
                  <TableCell>{claim.claim_type}</TableCell>
                  <TableCell>
                    {claim.images.map((imageUrl, imgIndex) => (
                      <div key={imgIndex}>
                        <Button
                          variant="outlined"
                          style={{ color: "blue" }}
                          onClick={() => openImageInNewTab(imageUrl)}
                        >
                          View Image {imgIndex + 1}
                        </Button>
                      </div>
                    ))}
                  </TableCell>
                  <TableCell>{claim.status}</TableCell>
                  <TableCell>{claim.bankName}</TableCell>
                  <TableCell>{claim.accNum}</TableCell>
                  <TableCell>{claim.accName}</TableCell>
                  <TableCell>{claim.swiftCode}</TableCell>
                  <TableCell>{claim.branchAdd}</TableCell>
                  <TableCell>{claim.contactNum}</TableCell>
                  <TableCell>
                    <input
                      id="adminAmount"
                      type="text"
                      placeholder="Enter Amount"
                    />
                  </TableCell>
                  <TableCell>
                    <input
                      id="adminMessage"
                      type="text"
                      placeholder="Enter Message"
                    />
                  </TableCell>
                  <TableCell>
                    <Dropdown>
                      <Dropdown.Toggle variant="success" id="dropdown-basic">
                        Update Status
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item
                          onClick={() => {
                            handleShowModal(claim.claim_id);
                            setSelectedClaimStatus("Observing");
                          }}
                        >
                          Observing
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => {
                            handleShowModal(claim.claim_id);
                            setSelectedClaimStatus("Verified");
                          }}
                        >
                          Verified
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => {
                            handleShowModal(claim.claim_id);
                            setSelectedClaimStatus("completed");
                          }}
                        >
                          Claim Generated
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => {
                            handleShowModal(claim.claim_id);
                            setSelectedClaimStatus("Request Rejected");
                          }}
                        >
                          Request Rejected
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Typography style={{ marginTop: "2rem" }} variant="h5">
          Completed Claims
        </Typography>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Claim ID</TableCell>
                <TableCell>Date of Claim Requested</TableCell>
                <TableCell>Date of Claim Amount Paid</TableCell>
                <TableCell>Claim Type</TableCell>
                <TableCell>Claim Amount</TableCell>
                <TableCell>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {completedClaims.map((claim, index) => (
                <TableRow key={index}>
                  <TableCell>{claim.claim_id}</TableCell>
                  <TableCell>{formatDate(claim.created_date)}</TableCell>
                  <TableCell>{formatDate(claim.updated_date)}</TableCell>
                  <TableCell>{claim.claim_type}</TableCell>
                  <TableCell>{claim.amount}</TableCell>
                  <TableCell>{claim.status}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Modal show={showModal} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>Update Claim Status</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure to update claim status to "{selectedClaimStatus}"?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Cancel
            </Button>
            <Button variant="success" onClick={handleStatusUpdate}>
              Update
            </Button>
          </Modal.Footer>
        </Modal>
    </Container>
  );
};

export default AdminClaim;
